export default "/images/0ca2592c41daa9a5322f88d040725e2f.avif";